/**
 * Optional extra slides served from `public/images/Theatre_images/<folder>/<file>`.
 * Use when you prefer static public URLs instead of (or in addition to) files under
 * `src/images/Theatre_images/<folder>/`.
 *
 * @type {{ folder: string, path: string }[]}
 */
export const theaterPublicSlideUrls = [];
